/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { MixtureListItemStyled } from "./MixtureListItemStyled";
import {
  MixtureChooseEnum,
  MixtureListItemProps,
} from "../../../entities/Mixture";
import Button from "../../../UI/Button/Button";
import decrement from "../../../assets/decrement.svg";
import increment from "../../../assets/increment.svg";

import { useAppDispatch } from "../../../store/store";
import { onOpenModal } from "../../Modal/slice/ModalSlice";
import { MODAL_TYPES } from "../../../entities/Modal";
import { USER_VALUE_DIRECTION } from "../../../entities/Customize";
import {
  updateCondimentGrams,
  updateCondimentParts,
  updateCondimentPercentage,
} from "../../Mixture/MixtureSlice";

import { getValueForKey } from "../../../context/translationsUtils";
import { TranslationContext } from "../../../context/TranslationContext";
import { TranslationContextInterface } from "../../../entities/Language";
import { TEST_ID } from "../../../shared/testid";
import { useSelector } from "react-redux";
import { getDataFromMixture } from "../../Mixture/selectors";
import { toFixedNumber } from "../../../utils/toFixedNumber";
import ImageComponent from "../../../UI/ImageComponent";

// TODO: Refactor this components
const MixtureListItem: React.FC<MixtureListItemProps> = ({
  condiment,
}: MixtureListItemProps) => {
  const [tempSelectedParts, setTempSelectedParts] = useState<number>(0);
  const [tempSelectedGrams, setTempSelectedGrams] = useState<string>("");
  const [tempSelectedPercentage, setTempSelectedPercentage] =
    useState<string>("");
  const [warning, setWarning] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { mixtureOption } = useSelector(getDataFromMixture);
  const { image = "", name } = condiment;
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);

  const checkGrams = () => {
    let value = parseFloat(tempSelectedGrams);
    if (value < condiment.minWeight) {
      setWarning(true);
      value = condiment.minWeight;
      setTempSelectedGrams(value?.toString());
    }
    if (value) {
      dispatch(
        updateCondimentGrams({
          condimentId: condiment.id,
          grams: parseFloat(value?.toString()),
        }),
      );
    } else {
      const metaGrams = condiment.meta.grams
        ? condiment.meta.grams.toString()
        : "";
      setTempSelectedGrams(metaGrams);
    }
  };

  const handleDetailsClick = () => {
    dispatch(
      onOpenModal({
        modalType: MODAL_TYPES.PRODUCT_PREVIEW,
        content: {
          name: condiment.name,
          image,
          description: condiment.description,
          botanicalOrigins: condiment.botanicalOrigins,
          botanicalFamilies: condiment.botanicalFamilies,
          recommendation: condiment.recommendation,
          latinNames: condiment.latinNames,
          history: condiment.history,
        },
      }),
    );
  };

  const onHandleCondimentValue = (
    type: USER_VALUE_DIRECTION,
    unit: MixtureChooseEnum,
  ) => {
    if (type === USER_VALUE_DIRECTION.PLUS) {
      if (unit === MixtureChooseEnum.PARTS) {
        dispatch(
          updateCondimentParts({
            condimentId: condiment.id,
            parts: condiment.meta.parts + 1,
          }),
        );
      }
      if (unit === MixtureChooseEnum.PERCENTAGE) {
        dispatch(
          updateCondimentPercentage({
            condimentId: condiment.id,
            percentage: condiment.meta.percentage + 1,
          }),
        );
      }
      if (unit === MixtureChooseEnum.GRAMS) {
        setWarning(false);
        dispatch(
          updateCondimentGrams({
            condimentId: condiment.id,
            grams: toFixedNumber(condiment.meta.grams + 1, 3),
          }),
        );
      }
    }

    if (type === USER_VALUE_DIRECTION.MINUS) {
      if (unit === MixtureChooseEnum.PARTS) {
        const parts =
          condiment.meta.parts > 1
            ? condiment.meta.parts - 1
            : condiment.meta.parts;
        dispatch(updateCondimentParts({ condimentId: condiment.id, parts }));
      }

      if (unit === MixtureChooseEnum.PERCENTAGE) {
        const percentage =
          condiment.meta.percentage > 1
            ? condiment.meta.percentage - 1
            : condiment.meta.percentage;
        dispatch(
          updateCondimentPercentage({ condimentId: condiment.id, percentage }),
        );
      }

      if (unit === MixtureChooseEnum.GRAMS) {
        let grams =
          condiment.meta.grams > 1
            ? condiment.meta.grams - 1
            : condiment.meta.grams;

        if (grams < condiment.minWeight) {
          setWarning(true);
          grams = condiment.minWeight;
        } else {
          setWarning(false);
        }

        dispatch(
          updateCondimentGrams({
            condimentId: condiment.id,
            grams: toFixedNumber(grams, 3),
          }),
        );
      }
    }
  };

  useEffect(() => {
    setWarning(false);
  }, [mixtureOption]);

  useEffect(() => {
    setTempSelectedParts(condiment.meta.parts);
  }, [condiment.meta.parts]);

  useEffect(() => {
    const metaGrams = condiment.meta.grams
      ? condiment.meta.grams.toString()
      : "";
    setTempSelectedGrams(metaGrams);
  }, [condiment.meta.grams]);

  useEffect(() => {
    const metaPercentage = condiment.meta.percentage
      ? condiment.meta.percentage.toString()
      : "";
    setTempSelectedPercentage(metaPercentage);
  }, [condiment.meta.percentage]);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (tempSelectedPercentage) {
        dispatch(
          updateCondimentPercentage({
            condimentId: condiment.id,
            percentage: parseFloat(tempSelectedPercentage),
          }),
        );
      } else {
        const metaPercentage = condiment.meta.percentage
          ? condiment.meta.percentage.toString()
          : "";
        setTempSelectedPercentage(metaPercentage);
      }
    }, 600);

    return () => {
      clearTimeout(delay);
    };
  }, [tempSelectedPercentage, dispatch]);

  useEffect(() => {
    const delay = setTimeout(() => {
      dispatch(
        updateCondimentParts({
          condimentId: condiment.id,
          parts: tempSelectedParts,
        }),
      );
    }, 1000);

    return () => {
      clearTimeout(delay);
    };
  }, [tempSelectedParts, dispatch]);

  const handleOnChangePercentage = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value.replace(/,/g, ".");
    const regex = /^(\d+|\d+\.?\d{0,2}|\d+\.)$/;

    if (value === "") {
      setTempSelectedPercentage("");
    }

    if (regex.test(value)) {
      setTempSelectedPercentage(value);
    }
  };

  const handeOnChangeGrams = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value.replace(/,/g, ".");
    const regex = /^(\d+|\d+\.?\d{0,2}|\d+\.)$/;
    if (value === "") {
      setTempSelectedGrams("");
    }
    if (regex.test(value) && !value.includes(".")) {
      const newWeight = parseFloat(value);
      setTempSelectedGrams(newWeight?.toString());
    } else {
      setTempSelectedGrams(value);
    }
  };

  return (
    <MixtureListItemStyled
      data-testid={`${TEST_ID.CREATE_MIX.LIST_ITEM}-${condiment.id}`}
    >
      <div className="mixture-item__left">
        <div className="mixture-item__image">
          <ImageComponent name={name} url={image} />
        </div>
        <div className="mixture-item__info">
          <div className="mixture-item__name">{name}</div>
          <div className="mixture-item__more">
            <Button
              name={getValueForKey(translations, "default.more_button")}
              className="small green"
              onClick={() => handleDetailsClick()}
            />
          </div>
        </div>
      </div>
      <div className="mixture-item__right">
        <div className="mixture-item__control">
          <div
            className="mixture-item__decrement"
            onClick={() =>
              onHandleCondimentValue(USER_VALUE_DIRECTION.MINUS, mixtureOption)
            }
            data-testid={TEST_ID.CREATE_MIX.LIST_ITEM_DECREMENT}
          >
            <img src={decrement} alt="Decrement" />
          </div>
          <div className="mixture-item__count">
            {mixtureOption === MixtureChooseEnum.PARTS && (
              <input
                type="number"
                value={tempSelectedParts}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  setTempSelectedParts(parseFloat(e.currentTarget.value))
                }
                data-testid={TEST_ID.MIX_CONFIGURATION.INPUT_PARTS}
                onWheel={(event) => event.currentTarget.blur()}
              />
            )}
            {mixtureOption === MixtureChooseEnum.GRAMS && (
              <input
                type="text"
                value={tempSelectedGrams}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handeOnChangeGrams(e)
                }
                data-testid={TEST_ID.MIX_CONFIGURATION.INPUT_GRAMS}
                onWheel={(event) => {
                  event.currentTarget.blur();
                }}
                onBlur={() => {
                  checkGrams();
                }}
              />
            )}
            {mixtureOption === MixtureChooseEnum.PERCENTAGE && (
              <input
                type="text"
                value={tempSelectedPercentage}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleOnChangePercentage(e)
                }
                data-testid={TEST_ID.MIX_CONFIGURATION.INPUT_PERCENTAGE}
                onWheel={(event) => event.currentTarget.blur()}
              />
            )}
          </div>
          <div
            className="mixture-item__increment"
            onClick={() =>
              onHandleCondimentValue(USER_VALUE_DIRECTION.PLUS, mixtureOption)
            }
            data-testid={TEST_ID.CREATE_MIX.LIST_ITEM_INCREMENT}
          >
            <img src={increment} alt="Increment" />
          </div>
        </div>
        {warning && (
          <span style={{ color: "red" }}>
            {getValueForKey(translations, "edit_mix.step_0_warning")}
            {`${condiment.minWeight}/${condiment.maxWeight}`}
          </span>
        )}
      </div>
    </MixtureListItemStyled>
  );
};

export default MixtureListItem;
